// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__rMEx+","fallback":"Cover_fallback__YM3-f"};